@use "../../styles/breakpoint.module.scss" as *;

.footerCopyright,
.footerAccessibility {
    p {
        font: var(--font-p-14);
    }

    [data-design-version="v2026"] & p {
        font: var(--font-nav-14);
        color: var(--gray-300);
    }

    [data-design-version="v2026"] &.footerAccessibility {
        order: 2;
    }

    [data-design-version="v2026"] &.footerCopyright {
        order: 3;
    }
}

.footerLogo {
    height: auto;
    margin: 0 auto;
    margin-bottom: var(--spacer-24);
    width: 10rem;

    [data-design-version="v2026"] & {
        order: 0;
        width: 100%;
        max-width: 100%;
        margin: var(--spacer-40) 0;
        opacity: 0.3;
    }
}

.legalContainer {
    text-align: center;
    padding-bottom: var(--spacer-24);

    [data-design-version="v2026"] & {
        text-align: left;
        padding-top: var(--spacer-40);
        padding-bottom: var(--spacer-40);
        display: flex;
        flex-direction: column;
        gap: var(--spacer-16);
    }
}

.legalLinks {
    align-items: center;
    padding-block: 10px;
    margin-bottom: var(--spacer-24);

    [data-design-version="v2026"] & {
        order: 1;
        display: flex;
        gap: var(--spacer-40);
        padding-block: 0;
        margin-bottom: 0;

        @media ($below-mobile) {
            flex-direction: column;
            gap: var(--spacer-16);
        }
    }
}

.link {
    padding-inline: var(--spacer-16);
    font: var(--font-p-14);
    line-height: 1.3;

    &:not(:last-child) {
        border-right: 1px solid var(--white);
    }

    [data-design-version="v2026"] & {
        padding-inline: 0;
        font: var(--font-nav-14);
        color: var(--off-white);
        text-decoration: underline;
        text-underline-offset: 0.1875em;

        &:not(:last-child) {
            border-right: 0;
        }
    }
}
